import Axios from 'axios'
import axiosHttp from './axiosHttp'
import ServerAPISetting from './ServerAPISetting'

export default {
  // -------- SIGN UP + VERIFY --------

  async signup(formData) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/signup'
      const result = await Axios.post(url, formData)
      return result
    } catch (error) {
      return error.response
    }
  },

  async verifySignUpToken(token) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/verifySignUpToken'
      const data = { token }
      const result = await Axios.post(url, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  async verifySignUpCode(data) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/verifySignUpCode'
      const result = await Axios.post(url, data) // expects { token, code }
      return result
    } catch (error) {
      return error.response
    }
  },

  // -------- LOGIN (PASSWORD) --------

  async login(formData) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/login'
      const result = await Axios.post(url, formData) // expects { email, password, keepSignIn? }
      return result
    } catch (error) {
      return error.response
    }
  },

  // -------- LOGIN (EMAIL CODE) --------

  async sendLoginCode(formData) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/sendLoginCode'
      const result = await Axios.post(url, formData) // expects { email }
      return result
    } catch (error) {
      return error.response
    }
  },

  async loginByCode(data) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/loginByCode'
      const result = await Axios.post(url, data) // expects { token, code }
      return result
    } catch (error) {
      return error.response
    }
  },

  async sendBookingPhoneCode(formData) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/sendBookingPhoneCode'
      const result = await Axios.post(url, formData)
      return result
    } catch (error) {
      return error.response
    }
  },

  async sendBookingEmailCode(formData) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/sendBookingEmailCode'
      const result = await Axios.post(url, formData)
      return result
    } catch (error) {
      return error.response
    }
  },

  async bookingPhoneLogin(data) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/bookingPhoneLogin'
      const result = await Axios.post(url, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  async bookingEmailLogin(data) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/bookingEmailLogin'
      const result = await Axios.post(url, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  // -------- RESET PASSWORD --------

  async forgotPassword(formData) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/forgotPassword'
      const result = await Axios.post(url, formData) // expects { email }
      return result
    } catch (error) {
      return error.response
    }
  },

  async resetPassword(data) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/resetPassword'
      const result = await Axios.post(url, data) // expects { pwd, confirmPwd, token, code }
      return result
    } catch (error) {
      return error.response
    }
  },

  async clientVerifySignUpAndLogin(data) {
    try {
      const url = ServerAPISetting.apiUrl() + '/client-auth/verifySignUpAndLogin'
      const result = await Axios.post(url, data)  // data = { token, code }
      return result
    } catch (error) {
      return error.response
    }
  },

  // -------- OPTIONAL: profile (only if you add GET /client-auth/profile) --------
  // Uses axiosHttp (auth header) like your getSessionMember() pattern:contentReference[oaicite:1]{index=1}
  async getClientSession() {
    try {
      const url = '/client-auth/profile'
      const result = await axiosHttp.get(url)
      if (result && result.data) return result.data
    } catch (error) {
      console.log(error)
    }
  },

  // Backward/forward compatible aliases (so AuthGuard can call either name)
  async getSessionClient() {
    return this.getClientSession()
  },

  async getProfile() {
    return this.getClientSession()
  },

  async getPromotionPreferences() {
    try {
      const result = await axiosHttp.get('/client-auth/promotion-preferences')
      return result?.data || null
    } catch (error) {
      console.log(error)
      return null
    }
  },

  async updatePromotionPreferences(payload) {
    try {
      const result = await axiosHttp.post('/client-auth/promotion-preferences', payload || {})
      return result?.data || null
    } catch (error) {
      console.log(error)
      return null
    }
  }
}
